import React, { useEffect, useState } from "react";
import { Tab, Badge, Row } from "react-bootstrap";
import Tabs from "react-bootstrap/Tabs";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import styled from "styled-components";
import { Modal } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import SideBar from "../components/Sidebar";
import Navbar from "../components/Navbar";

const ProgressBar = styled.div`
  position: absolute;
  margin-top: 50vh;
  margin-left: 50vw;
`;

const View = styled.div`
  display: flex;
  width: calc(100% - 30px);
`;

const Container = styled.div`
  display: flex;
  width: calc(100% - 30px);
`;

const Videos = () => {
  const location = useLocation();
  let path = location.pathname.split("/");
  const id = path[2];
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [video, setVideo] = useState([]);
  const [urlId, setUrlId] = useState("");
  const [key, setKey] = useState("home");
  //console.log("videos", path[2]);

  const getVideo = async () => {
    setIsModalOpen(true);

    try {
      const response = await axios.post(
        `https://e-learning-ewv6.onrender.com/videos`,
        {
          video_id: id,
        },
        {
          headers: {
            Authorization: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      setVideo(response.data);
      let url = response.data.url;

      url = url.split("/");
      setUrlId("https://drive.google.com/file/d/" + url[5] + "/preview");
      setUrlId("https://drive.google.com/uc?id=" + url[5]);
      setTimeout(() => setIsModalOpen(false), 1000);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVideo();
  }, []);

  return (
    <div style={{ height: "100vh" }}>
      <Navbar></Navbar>
      <Modal open={isModalOpen}>
        <ProgressBar>
          <CircularProgress style={{ color: "white" }} />
        </ProgressBar>
      </Modal>

      <View>
        <SideBar></SideBar>
        <Container 
         style={{
            overflow: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
         className="p-2">
          <Row className="w-100 d-flex justify-content-center p-3">
            <ReactPlayer width="90%" height="100%" url={urlId} controls />
            <h3 className="mx-5">
              <Badge bg="success" className="w-100 d-flex justify-content-center ">{video.title}</Badge>
            </h3>
          </Row>
          <Row>
            <p className="my-auto mx-4 flex-column ">
              <h2> Machine learning?</h2>
              Machine learning is a branch of artificial intelligence (AI) and
              computer science which focuses on the use of data and algorithms
              to imitate the way that humans learn, gradually improving its
              accuracy. IBM has a rich history with machine learning. One of its
              own, Arthur Samuel, is credited for coining the term, “machine
              learning” with his research (PDF, 481 KB) (link resides outside
              IBM) around the game of checkers
            </p>
          </Row>
        </Container>
      </View>
    </div>
  );
};

export default Videos;
